import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlipToBackIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flip_to_back"}/>
}
